export default __webpack_public_path__ + "static/media/boite13.57747997.jpg";